import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { TermsV1_0 } from "@/components/auth/legal/versions/terms/TermsV1_0";

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 bg-background/95 backdrop-blur border-b border-border px-4 sm:px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <Link to="/">
            <Button variant="ghost" size="icon" className="text-foreground hover:text-foreground/80">
              <ArrowLeft className="h-5 w-5" />
            </Button>
          </Link>
          <h1 className="text-xl sm:text-2xl font-bold text-foreground">
            Termos de Uso
          </h1>
        </div>
      </header>
      
      <ScrollArea className="flex-1">
        <main className="max-w-4xl mx-auto">
          <TermsV1_0 />
        </main>
      </ScrollArea>
    </div>
  );
};

export default Terms;
